import { createContext, type ReactNode, useContext, useMemo, useState } from 'react';

export type HeaderLiveMetricsContextValue = {
  liveEquityValue: number | null;
  liveFirmTotal: number | null;
  setLiveEquityValue: (value: number | null) => void;
  setLiveFirmTotal: (value: number | null) => void;
};

const defaultContextValue: HeaderLiveMetricsContextValue = {
  liveEquityValue: null,
  liveFirmTotal: null,
  setLiveEquityValue: () => {},
  setLiveFirmTotal: () => {},
};

const HeaderLiveMetricsContext = createContext<HeaderLiveMetricsContextValue>(defaultContextValue);

HeaderLiveMetricsContext.displayName = 'HeaderLiveMetricsContext';

type HeaderLiveMetricsProviderProps = {
  children: ReactNode;
};

export const HeaderLiveMetricsProvider = ({ children }: HeaderLiveMetricsProviderProps) => {
  const [liveEquityValue, setLiveEquityValue] = useState<number | null>(null);
  const [liveFirmTotal, setLiveFirmTotal] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      liveEquityValue,
      liveFirmTotal,
      setLiveEquityValue,
      setLiveFirmTotal,
    }),
    [liveEquityValue, liveFirmTotal]
  );

  return <HeaderLiveMetricsContext.Provider value={value}>{children}</HeaderLiveMetricsContext.Provider>;
};

export const useHeaderLiveMetrics = (): HeaderLiveMetricsContextValue =>
  useContext(HeaderLiveMetricsContext);
